import { render, staticRenderFns } from "./Page4Store.vue?vue&type=template&id=5998fc61&scoped=true"
import script from "./Page4Store.vue?vue&type=script&lang=js"
export * from "./Page4Store.vue?vue&type=script&lang=js"
import style0 from "./Page4Store.vue?vue&type=style&index=0&id=5998fc61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998fc61",
  null
  
)

export default component.exports